import React from 'react';
import FrequentlyAskedQuestions from 'components/FrequentlyAskedQuestions/FrequentlyAskedQuestions';

const improvedScoreChangeCopies = [
  {
    question: 'What are the credit score bands?',
    answer: `Credit score bands may vary depending on the credit bureau or lender. These are the score bands used in this app.
    <p>
      720-850 Excellent <br />
      640-719 Good<br />
      550-639 Fair<br />
      500-549 Poor<br />
      400-499 Very Poor
    </p>`,
  },
  {
    question: 'Why do higher score bands result in better credit offers?',
    answer:
      'A higher credit score band reflects a history of responsible credit behavior. Lenders perceive this as less risky and so are more likely to extend credit.',
  },
  {
    question: 'Is it worthwhile getting into the top credit score band?',
    answer:
      'Moving into the top credit score band can result in access to even more favorable loan terms, interest rates, credit limits and financial opportunities.',
  },
];

const FrequentlyAskedQuestionsWrapper = props => {
  const { isScoreBandImproved, config } = props;
  let frequentlyAskedQuestion = improvedScoreChangeCopies;
  if (!isScoreBandImproved) {
    frequentlyAskedQuestion =
      config?.notificationAlerts?.accountChangeScoreBand?.faq;
  }
  return (
    <FrequentlyAskedQuestions
      frequentlyAskedQuestion={frequentlyAskedQuestion}
    />
  );
};

export default FrequentlyAskedQuestionsWrapper;
